/* ============================================================
   Spiri Sport — Custom JS
   Stretch theme | Last updated 6 July 2026
   Loaded via assets/custom.js with defer, from layout/theme.liquid:
     <script src="{{ 'custom.js' | asset_url }}" defer></script>
   Keep custom scripts here, not inline in theme.liquid.

   Two product-page enhancements, driven by one MutationObserver:
   1. Selected variant summary printed on the price line.
   2. Trailing colon stripped from variant labels (Flavor:, Size:).
   ============================================================ */

(function () {
  // Remove the trailing colon the theme prints after each option name.
  function stripColons(root) {
    root.querySelectorAll('.variant-picker__option legend').forEach(function (l) {
      var t = l.textContent.replace(/[:：]\s*$/, '');
      if (t !== l.textContent) l.textContent = t;
    });
  }

  // Build "Flavor, Size" style summary from the checked variant radios, falling
  // back to the selected cross-product swatch when the page has no radios.
  //
  // Why the fallback: on the accessories template each size is its own product
  // (drink-bottle-550-ml / drink-bottle-750-ml), tied together by the theme's
  // "product_variations" block. That renders <a class="block-swatch is-selected">
  // links, not radio inputs, and the real "Size picker" (variant_picker) block is
  // disabled on that template - so there are no radios on the page at all and the
  // price line came up blank.
  //
  // Why radios stay the primary source: on the drink-mix pages the FLAVOUR row is
  // also a cross-product block, so reading swatches *in addition to* radios would
  // turn "30 SERVE BAG (810G)" into "LEMON CITRUS, 30 SERVE BAG (810G)". Radios
  // first, swatches only if there are none, keeps those pages unchanged.
  function summaryText(root) {
    var fromRadios = Array.prototype.slice
      .call(root.querySelectorAll('.variant-picker input[type="radio"]:checked'))
      .sort(function (a, b) {
        return (+a.getAttribute('data-option-position') || 0) - (+b.getAttribute('data-option-position') || 0);
      })
      .map(function (r) {
        var l = root.querySelector('label[for="' + CSS.escape(r.id) + '"]');
        return l ? l.textContent.trim() : '';
      })
      .filter(Boolean)
      .join(', ');

    if (fromRadios) return fromRadios;

    return Array.prototype.slice
      .call(root.querySelectorAll('.variant-picker__option .block-swatch.is-selected'))
      .map(function (a) {
        return a.textContent.trim();
      })
      .filter(Boolean)
      .join(', ');
  }

  function init() {
    var root = document.querySelector('product-rerender') || document.querySelector('.product');
    if (!root) return;

    var obs;
    function render() {
      // Detach while we mutate so our own writes don't retrigger the observer.
      if (obs) obs.disconnect();

      stripColons(root);

      var pl = root.querySelector('.product-info__block-item[data-block-type="price"] price-list');
      if (pl) {
        var t = summaryText(root);
        var sum = pl.querySelector('.variant-summary');

        if (t) {
          if (!sum) {
            sum = document.createElement('span');
            sum.className = 'variant-summary';
            pl.insertBefore(sum, pl.firstChild);
          }
          // Set the class here rather than only on creation, so it is always in
          // step with there being summary text to show.
          pl.classList.add('vsum-row');
          if (sum.textContent !== t) sum.textContent = t;
        } else {
          // Nothing to summarise (a product with no options at all). Drop the
          // span and the vsum-row class: that class is justify-content:
          // space-between, which with an empty first child would shove the price
          // out to the right-hand edge on its own.
          if (sum) sum.remove();
          pl.classList.remove('vsum-row');
        }
      }

      if (obs) obs.observe(root, { childList: true, subtree: true });
    }

    render();

    // Update immediately on selection, and again if the theme re-renders the block.
    root.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.variant-picker input[type="radio"]')) render();
    });
    obs = new MutationObserver(render);
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Header icons as text: render the Account, Search and Bag
   links as text labels ("Account" / "Search" / "Bag") instead
   of SVG icons. CSS (custom.css) hides the icons + sr-only
   labels, orders them Search / Account / Bag, and styles the
   olive count pill. This writes the visible text and keeps the
   Bag count live: the number lives in the theme's <cart-count>
   element, whose text updates on add/remove, and an observer on
   the header actions list mirrors it into the .header__bag-count
   badge (hidden via .is-empty when the bag is empty). The
   observer also re-labels the account link if the
   shopify-account web component re-renders after hydration.
   ============================================================ */
(function () {
  function cartCount() {
    var c = document.querySelector('.header__cart-link cart-count');
    if (!c) return 0;
    var n = parseInt((c.textContent || '').trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  // Ensure a link has a .header__icon-text span and set its text.
  function label(sel, text) {
    var a = document.querySelector(sel);
    if (!a) return null;
    var span = a.querySelector('.header__icon-text');
    if (!span) {
      span = document.createElement('span');
      span.className = 'header__icon-text';
      a.appendChild(span);
    }
    if (span.textContent !== text) span.textContent = text;
    return a;
  }

  // The shopify-account widget renders a dropdown (open shadow DOM) whose menu
  // includes a "Profile" link. Rename it to "Account" so the wording is
  // consistent with the header label. Guarded to only touch an exact "Profile".
  function renameAccountMenu(root) {
    if (!root) return;
    root.querySelectorAll('a').forEach(function (a) {
      a.childNodes.forEach(function (c) {
        if (c.nodeType === 3 && c.textContent.trim() === 'Profile') {
          c.textContent = c.textContent.replace('Profile', 'Account');
        }
      });
    });
  }

  function render() {
    // Account: label whichever avatar slot is present (signed out or in).
    label('.header__account-link [slot="signed-out-avatar"], .header__account-link [slot="signed-in-avatar"]', 'Account');
    label('.header__search-link a[href="/search"]', 'Search');

    // Cart: text label plus an olive count badge that hides when empty.
    var bag = label('.header__cart-link a[href="/cart"]', 'Cart');
    if (bag) {
      var badge = bag.querySelector('.header__bag-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'header__bag-count';
        bag.appendChild(badge);
      }
      var n = cartCount();
      var t = String(n);
      if (badge.textContent !== t) badge.textContent = t;
      badge.classList.toggle('is-empty', n <= 0);
    }
  }

  function init() {
    render();
    // Re-run when the theme updates the cart count or re-renders a link.
    // The text-compare guards keep this from looping.
    var actions = document.querySelector('.header__cart-link');
    actions = actions && actions.parentElement;
    if (actions) {
      new MutationObserver(render).observe(actions, {
        childList: true, subtree: true, characterData: true, attributes: true
      });
    }
    // Account dropdown "Profile" -> "Account". Shadow-DOM changes don't bubble
    // to the header observer, so watch the widget's shadow root separately.
    var acct = document.querySelector('shopify-account');
    if (acct && acct.shadowRoot) {
      renameAccountMenu(acct.shadowRoot);
      new MutationObserver(function () {
        renameAccountMenu(acct.shadowRoot);
      }).observe(acct.shadowRoot, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ============================================================
   Spiri Sport — World menu sheet
   Rebuilds the desktop "World" dropdown as a full-width sheet of
   titled entries. Styling lives in custom.css ("World dropdown").

   Real links still come from Navigation (Main menu → World), so
   renaming or repointing one there still works. Only the
   description text and the not-yet-built entries live here: when
   a section ships, add it in Navigation and delete it from
   COMING_SOON below.
   ============================================================ */

(function () {
  // Line of description under a link, keyed by its menu title (lowercased).
  var DESCRIPTIONS = {
    'formula science': 'What is in Rebound, and why'
  };

  // Announced but not built. Rendered as faded entries with a chip.
  var COMING_SOON = ['Ingredient IQ', 'Fuelling Guide'];

  function el(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  // A real entry is an <a>; a coming-soon one is a <span> so it can't be clicked.
  function entry(title, description, href) {
    var item = el(href ? 'a' : 'span', 'world-sheet__item' + (href ? '' : ' world-sheet__item--soon'));
    if (href) item.href = href;
    item.appendChild(el('span', 'world-sheet__title', title));
    if (description) item.appendChild(el('span', 'world-sheet__desc', description));
    if (!href) item.appendChild(el('span', 'world-sheet__chip', 'Coming soon'));
    return item;
  }

  function worldMenu() {
    var links = document.querySelectorAll('.header__primary-nav > ul > li > a[aria-controls]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].textContent.trim().toLowerCase() === 'world') {
        return document.getElementById(links[i].getAttribute('aria-controls'));
      }
    }
    return null;
  }

  function render() {
    var menu = worldMenu();
    // The flag also stops the MutationObserver below from re-entering.
    if (!menu || menu.dataset.worldSheet === 'on') return;

    var links = menu.querySelectorAll(':scope > ul > li > a');
    if (!links.length) return;

    // Keep the ul > li shape: the theme staggers those on open.
    var list = el('ul', 'unstyled-list world-sheet');

    Array.prototype.forEach.call(links, function (link) {
      var title = link.textContent.trim();
      var li = document.createElement('li');
      li.appendChild(entry(title, DESCRIPTIONS[title.toLowerCase()], link.getAttribute('href')));
      list.appendChild(li);
    });

    COMING_SOON.forEach(function (title) {
      var li = document.createElement('li');
      li.appendChild(entry(title, null, null));
      list.appendChild(li);
    });

    menu.innerHTML = '';
    menu.appendChild(list);
    menu.dataset.worldSheet = 'on';
  }

  function init() {
    render();
    // Rebuild if the theme editor re-renders the header section.
    var nav = document.querySelector('.header__primary-nav');
    if (nav) {
      new MutationObserver(render).observe(nav, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Spiri Sport — Welcome discount popup
   Confirms on screen that a discount link worked. Markup lives in
   snippets/welcome-discount-popup.liquid; styling in custom.css
   ("Welcome discount popup").

   How the discount gets here: a Shopify /discount/CODE URL (what the
   event QR code points at) applies the code and 302s to the store,
   leaving a readable "discount_code" cookie behind. That cookie is
   the trigger for this popup.

   Which codes we act on is decided by the CODES allowlist below,
   which carries the full reasoning - read it before editing.

   Shown once per device, ever - see the note on seenKey below for why
   that is localStorage rather than per-session.

   Typing a code into the cart field does NOT come through here - that
   path posts to /cart/update.js and never touches the cookie - so this
   only ever fires for people arriving on a link.

   To add a future event code: add an entry to CODES. Nothing else.
   ============================================================ */

(function () {
  /* ---------------------------------------------------------
     THE ALLOWLIST. Only codes listed here ever produce a popup.

     Why an allowlist rather than just showing whatever code is in
     the cookie: Shopify's /discount/CODE endpoint sets the cookie
     WITHOUT checking that the code exists, is spelled right, has
     not expired, or has any usage left. Verified by hand against
     the live store - /discount/FAKECODE99 (a string invented on
     the spot) is accepted and stored exactly like a real code.
     Validation only happens later, at the cart and at checkout.

     So cookie presence proves someone followed a discount link. It
     does NOT prove they got a discount. If we popped up on cookie
     presence alone, a mistyped QR code or a code Rosie expired
     after an event would greet people with a confident "your 15%
     off is applied" that then vanishes at checkout - worse than
     showing nothing, because it reads as a bait and switch.

     Listing the code here is us asserting "this one is real and we
     stand behind these words". Anything not listed is ignored in
     silence: the discount may well still apply, we just decline to
     promise it. Erring towards saying nothing is deliberate.

     Only the heading and body are per-code. The button label is the
     same for everyone and lives in the Liquid snippet.

     TO ADD A FUTURE EVENT CODE: add an entry below, and check the
     discount is actually live in Shopify admin first (no expiry
     before the event, no usage cap that a busy day would exhaust).
     Nothing else in this file needs to change.
     --------------------------------------------------------- */
  var CODES = {
    WELCOME15: {
      heading: '15% off your first order',
      body: 'WELCOME15 code will be automatically applied at checkout.'
    }
  };

  // Let the page paint first: opening on the same frame as arrival reads as a
  // glitch rather than a response to the scan.
  var DELAY = 700;

  // Read the codes Shopify has put in session. The cookie is a single slot that
  // a later discount link overwrites, but one link can carry several codes
  // (/discount/A,B), in which case they arrive comma-separated and URL-encoded.
  function sessionCodes() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!match) return [];
    var raw = match[1];
    try { raw = decodeURIComponent(raw); } catch (e) { /* keep the raw value */ }
    return raw.split(',').map(function (code) {
      return code.trim().toUpperCase();
    }).filter(Boolean);
  }

  /* Once per code per device, remembered permanently in localStorage.

     This was sessionStorage first, which was wrong in two ways. Shopify's
     discount_code cookie is a session cookie (no Expires, no Max-Age) shared
     across every tab, while sessionStorage is per-tab. So opening the site in
     a second tab gave a fresh sessionStorage but the same live cookie, and the
     popup fired again - verified in a real browser.

     That also broke the promise in the copy. Someone who scanned, bought, then
     opened the site again in a new tab was told "15% off your first order"
     after their first order, when the code may well be spent.

     localStorage is shared across tabs and survives restarts, so the popup is
     shown once per device and never repeats regardless of what Shopify does
     with the cookie after checkout. Keyed by code, so a future event code
     still gets its own showing. */
  function seenKey(code) { return 'spiri:welcome-discount:' + code; }

  function alreadySeen(code) {
    try { return localStorage.getItem(seenKey(code)) === 'true'; }
    catch (e) { return false; } // private mode etc: better to show twice than never
  }

  function markSeen(code) {
    try { localStorage.setItem(seenKey(code), 'true'); } catch (e) {}
  }

  function init() {
    var modal = document.getElementById('welcome-discount-popup');
    if (!modal) return;

    // First code we recognise wins. One link can carry several codes
    // (/discount/A,B), and they may arrive in any order, so scan the whole
    // list rather than only checking the first. Codes missing from CODES are
    // skipped, never guessed at - see the allowlist note above for why.
    var codes = sessionCodes();
    var code = null;
    for (var i = 0; i < codes.length; i++) {
      if (CODES.hasOwnProperty(codes[i])) { code = codes[i]; break; }
    }
    if (!code || alreadySeen(code)) return;

    var heading = modal.querySelector('[data-welcome-discount-heading]');
    var body = modal.querySelector('[data-welcome-discount-body]');
    if (!heading || !body) return;
    heading.textContent = CODES[code].heading;
    body.textContent = CODES[code].body;

    markSeen(code);

    // x-modal is defined by theme.js, which may not have run yet.
    window.customElements.whenDefined('x-modal').then(function () {
      setTimeout(function () { modal.show(); }, DELAY);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
